import { createBrowserRouter } from 'react-router-dom';
import RootLayout from '../layouts/RootLayout';
import AppLayout from '../layouts/AppLayout';
import AdminLayout from '../layouts/AdminLayout';
import ProtectedRoute from '../auth/ProtectedRoute';
import RoleGuard from '../auth/RoleGuard';
import HomeRedirect from '../auth/HomeRedirect';
import { ROLES } from '../constants/roles';
import Login from '../pages/Login';
import AccessDenied from '../pages/AccessDenied';
import NotFound from '../pages/NotFound';
import ComingSoon from '../pages/ComingSoon';
import CallList from '../pages/calls/CallList';
import CallDetail from '../pages/calls/CallDetail';
import ReviewQueue from '../pages/ReviewQueue';
import Dashboard from '../pages/Dashboard';
import ReportView from '../pages/reports/ReportView';
import ReportsHome from '../pages/reports/ReportsHome';
import { REPORTS } from '../constants/reports';
import Users from '../pages/admin/Users';
import Organization from '../pages/admin/Organization';
import AuditLog from '../pages/admin/AuditLog';
import IngestionErrors from '../pages/admin/IngestionErrors';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/403', element: <AccessDenied /> },
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <HomeRedirect /> },

          // Consumer pages; report components apply their per-type UX role guard.
          {
            element: <AppLayout />,
            children: [
              { path: 'dashboard', element: <Dashboard /> },
              { path: 'calls', element: <CallList /> },
              { path: 'calls/:callId', element: <CallDetail /> },
              { path: 'review-queue', element: <ReviewQueue /> },
              { path: 'reports', element: <ReportsHome /> },
              ...REPORTS.map((report) => ({ path: `reports/${report.type}`, element: <ReportView reportType={report.type} title={report.title} /> })),
              { path: 'reports/script-compliance', element: <ComingSoon title="انطباق اسکریپت (مسدود تا دریافت اسکریپت/KB کارفرما — دروازهٔ G)" /> },
            ],
          },

          // Administration — System Administrator only.
          {
            element: <RoleGuard allow={[ROLES.SystemAdministrator]} />,
            children: [
              {
                element: <AdminLayout />,
                children: [
                  { path: 'admin/users', element: <Users /> },
                  { path: 'admin/organization', element: <Organization /> },
                  { path: 'admin/audit', element: <AuditLog /> },
                  { path: 'admin/ingestion-errors', element: <IngestionErrors /> },
                ],
              },
            ],
          },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
